var map = {
	"./IMG_7311.jpeg": 473,
	"./IMG_7314.jpeg": 6424,
	"./IMG_7315.jpeg": 1127,
	"./IMG_7338.jpeg": 4111,
	"./bike_spirit.jpeg": 8580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4221;